<y42-logo-loader *ngIf="state.dataLoading" class="center-absolute z-index-3 bg-squared-pattern"> </y42-logo-loader>

<div class="gojs-diagram-panel">
  <div #diagramRef class="gojs-diagram"></div>

  <y42-gojs-overview
    *ngIf="diagram && showOverview"
    [diagram]="diagram"
    [position]="overviewPosition"
  ></y42-gojs-overview>

  <div *ngIf="!state.diagramHasNodes" class="w-full h-full absolute aligner flex-col" style="top: 0; z-index: 2">
    <div #ngContent>
      <ng-content></ng-content>
    </div>

    <ng-container *ngIf="!ngContent.innerHTML">
      <y42-empty-state [header]="'There are no nodes'" [body]="emptyDiagramMessage"> </y42-empty-state>
    </ng-container>
  </div>
</div>
